import React, { useEffect, useState } from "react";
import "../../src/App.css";
import 'sweetalert2/dist/sweetalert2.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { IoMdClose } from "react-icons/io";
import { CiCircleInfo } from "react-icons/ci";
import config from "./config";
import { makeApiRequest } from "../axiosService/apiCall";
import DataTable from 'react-data-table-component';
import { Spinner } from "react-bootstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { ImBubbles3 } from "react-icons/im";

function Transaction() {
    const [depositData, setDepositData] = useState([]);
    const [withdrawData, setWithdrawData] = useState([]);
    const [activeTab, setActiveTab] = useState('deposit');
    const [loading, setLoading] = useState(true);
    const [totalCommissionFee, setTotalCommissionFee] = useState(0);
    const [copiedValue, setCopiedValue] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [filterStatus, setFilterStatus] = useState(null);
    const [selectedReason, setSelectedReason] = useState("");

    const handleOpenModal = (reason) => {

        setSelectedReason(reason);
    };
    const getDepositHistory = async () => {
        try {
            let params = {
                url: `depositHistory`,

                method: 'GET',
            };
            let response = await makeApiRequest(params);

            if (response.status === true && response.getDepositHistorys) {
                const userList = response.getDepositHistorys;
                // console.log('depositHistory', userList)
                setDepositData(userList);
            } else {
                setDepositData([]);
            }
        } catch (error) {
            // console.log('error', error);
        } finally {
            setLoading(false);
        }
    };
    const getWithdrawHistory = async () => {
        try {
            let params = {
                url: `WithdarwHistoryData`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);

            if (response.status === true && response.getWithDrawHistory) {
                const userList = response.getWithDrawHistory;
                // console.log('WithdarwHistoryData', userList)
                setWithdrawData(userList);
                setTotalCommissionFee(response.totaladmincommission[0].totalAdminCommissionFee);
            } else {
                setWithdrawData([]);
            }
        } catch (error) {
            // console.log('error', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getDepositHistory();
        getWithdrawHistory();
    }, []);
    const compressString = (str) => {
        if (!str) {
            return '';
        }
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };
    const handleCopy = (value) => {
        setCopiedValue(value);
        setTimeout(() => setCopiedValue(''), 2000);
    };




    // const filteredDeposit = depositData.filter(row => {
    //     const formattedDate = row.Timestamp ? new Date(row.Timestamp * 1000).toLocaleDateString('en-IN') : "-";

    //     return (
    //         (row.userDetails[0].email && row.userDetails[0].email.toLowerCase().includes(searchQuery.toLowerCase())) ||
    //         formattedDate.includes(searchQuery)
    //     );
    // });
    const filteredDeposit = depositData.filter(row => {


        const formattedDate = row.Timestamp
            ? new Date(row.Timestamp * 1000).toLocaleDateString('en-GB') // 'en-GB' ensures "dd/MM/yyyy" format
            : "-";

        return (
            (row.userDetails[0].email && row.userDetails[0].email.toLowerCase().includes(searchQuery.toLowerCase())) ||
            formattedDate.includes(searchQuery) || // checking formatted date in "dd/MM/yyyy" format
            (row.Timestamp && row.Timestamp.toString().includes(searchQuery)) // checking raw timestamp
        );
    });

    const columnsDeposit = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: true,
            width: "100px"
        },
        {
            name: 'Date',
            selector: row => new Date(row.Timestamp * 1000).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }), sortable: true,
            width: "200px"
        },
        {
            name: 'Email',
            selector: row => row.userDetails[0].email,
            sortable: true,
            width: "350px"
        },
        {
            name: 'From Address',
            selector: row => row.FromAddress ? compressString(row.FromAddress) : "N/A",
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div className="no-wrap-cell">
                    {row.FromAddress ? (
                        <>
                            {compressString(row.FromAddress)}
                            <CopyToClipboard className="ms-2" text={row.FromAddress} onCopy={() => handleCopy(row.FromAddress)}>
                                <FontAwesomeIcon icon={faCopy} />
                            </CopyToClipboard>
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            ),
        },

        {
            name: 'To Address',
            selector: row => compressString(row.ToAddress),
            sortable: true,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.ToAddress)}
                    <CopyToClipboard className="ms-2" text={row.ToAddress} onCopy={() => handleCopy(row.ToAddress)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'Transaction Hash',
            selector: row => {
                if (row.TransferHash) {
                    if (row.TransferHash && row.tokenSymbol === "texa") {
                        return (
                            <a href={`${config.TEXA_URL}${row.TransferHash}`} target="_blank" rel="noopener noreferrer">
                                {compressString(row.TransferHash)}
                            </a>
                        );
                    } else {
                        return (
                            <a href={`${config.BNB_URL}/tx/${row.TransferHash}`} target="_blank" rel="noopener noreferrer">
                                {compressString(row.TransferHash)}
                            </a>
                        );
                    }

                }

                return null
            },
            sortable: true,
            width: "200px"

        },
        {
            name: 'Amount',
            selector: row => row.tokenSymbol == "texa" ? row.TexaAmount : row.UsdtAmount,
            sortable: true,
            width: "150px"

        },
        {
            name: 'Coin',
            selector: row => row.tokenSymbol,
            sortable: true,
            // width: "150px"
        },
        {
            name: 'Admin Move',
            selector: row => row.adminMoveStatus == 1 ? "Moved" : "Not Moved",
            sortable: true,
            width: "150px"
        },

    ];




    const columnsWithdraw = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: 'Request Date',
            selector: row => new Date(row.WithDrawReqTime).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }), sortable: true,
            width: "200px"

        },
        {
            name: 'Approval or Reject Date',
            selector: row =>
                row?.WithDrawApprovalorRejectTime
                    ? new Date(row.WithDrawApprovalorRejectTime).toLocaleString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    })
                    : "Not Available",
            sortable: true,
            width: "300px"
        }
        ,
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            width: "300px"

        },
        {
            name: 'Email',
            selector: row => row.userDetails[0].email,
            sortable: true,
            width: "300px"

        },
        {
            name: 'From Address',
            selector: row => row.FromAddress ? compressString(row.FromAddress) : "N/A",
            sortable: true,
            width: "300px",

            cell: (row) => (
                <div className="no-wrap-cell">
                    {row.FromAddress ? (
                        <>
                            {compressString(row.FromAddress)}
                            <CopyToClipboard className="ms-2" text={row.FromAddress} onCopy={() => handleCopy(row.FromAddress)}>
                                <FontAwesomeIcon icon={faCopy} />
                            </CopyToClipboard>
                        </>
                    ) : (
                        "-"
                    )}
                </div>
            ),
        },
        {
            name: 'To Address',
            selector: row => compressString(row.toAddress),
            sortable: true,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.toAddress)}
                    <CopyToClipboard className="ms-2" text={row.toAddress} onCopy={() => handleCopy(row.toAddress)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },

        {
            name: 'Transaction Hash',
            selector: row => {
                if (row.coin && row.txHash) {
                    return (
                        <a href={`${config.TEXA_URL}${row.txHash}`} target="_blank" rel="noopener noreferrer">
                            {compressString(row.txHash)}
                        </a>
                    );
                } else if (row.coin === "TRX" && row.txHash) {
                    return (
                        <a href={`${config.TRX_Explorer_URL}/transaction/${row.txHash}`} target="_blank" rel="noopener noreferrer">
                            {compressString(row.txHash)}
                        </a>
                    );
                } else if (row.coin === "BTC" && row.txHash) {
                    return (
                        <a href={`${config.BTC_URL}/tx/${row.txHash}`} target="_blank" rel="noopener noreferrer">
                            {compressString(row.txHash)}
                        </a>
                    );
                }
                return "-";
            },
            sortable: true,
            width: "200px"
        },

        {
            name: 'Total Amount',
            selector: row => row.originalAmount ? row.originalAmount : "-",
            sortable: true,
            width: "150px"
        },

        {
            name: 'Transaction Amount',
            selector: row => row.amount,
            sortable: true,
            width: "200px"
        },

        {
            name: 'Fee',
            selector: row => row.adminCommissionFee ? row.adminCommissionFee : "-",
            sortable: true,
            width: "150px"
        },
        {
            name: 'withdraw Status',
            selector: row => {

                const status = row?.status;

                switch (status) {

                    case 1:
                        return "pending";
                    case 2:
                        return "Approved";
                    case 3:
                        return "Rejected";

                    default:
                        return "Unknown";
                }
            },
            sortable: true,
            width: "200px"
        },
        {
            name: 'Reject Reason',
            selector: row => <div className='d-flex'>
                {row.Rejectreason
                    ? row.Rejectreason.substring(0, 15) + "..."
                    : "N/A"
                }
                {row.Rejectreason
                    ? <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#rejectReasonModal"
                        onClick={() => handleOpenModal(row.Rejectreason)}>
                        <ImBubbles3 />
                    </p>
                    : ""
                }


                <div className="modal fade" id="rejectReasonModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="rejectReasonLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="rejectReasonLabel">Reject Reason</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                                {selectedReason || "No reason provided"}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,

            sortable: true,
            width: "350px"

        },

    ];


    const filteredWithdraw = withdrawData.filter(row => {
        const formatDate = (dateString) => {
            if (!dateString) return "-";
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        const requestTime = formatDate(row.WithDrawReqTime);
        const approvalTime = formatDate(row.WithDrawApprovalTime);

        const matchesStatus = filterStatus ? row.status === filterStatus : true;

        const matchesSearch =
            (row.userDetails[0]?.email && row.userDetails[0].email.toLowerCase().includes(searchQuery.toLowerCase())) ||
            requestTime.includes(searchQuery) ||
            approvalTime.includes(searchQuery);

        return matchesStatus && matchesSearch;
    });



    // const filteredWithdraw = withdrawData.filter(row => {
    //     const formattedDate = row.Timestamp ? new Date(row.Timestamp * 1000).toLocaleDateString('en-IN') : "-";

    //     return (
    //         (row.userDetails[0].email && row.userDetails[0].email.toLowerCase().includes(searchQuery.toLowerCase())) ||
    //         formattedDate.includes(searchQuery)
    //     );
    // });

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            if (typeof selector(a) === "string") {
                const aField = selector(a).toLowerCase();
                const bField = selector(b).toLowerCase();

                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            } else {
                const aField = selector(a).props.children ? parseFloat(selector(a).props.children) : 0;
                const bField = selector(b).props.children ? parseFloat(selector(b).props.children) : 0;
                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            }
        });
    };

    return (
        <div className="App">
            <ToastContainer />
            <div className="container-fluid">
                <div className="custom-saled-order text-dark" style={{ marginLeft: "15px" }}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="py-3 justify-content-center d-flex justify-content-between">
                                <h3 className="component-user text-center ms-lg-0">Transaction History</h3>
                            </div>
                            <div className="custom-inside-saled-order  mt-0">
                                <ul className="nav nav-pills mb-3 me-lg-0 text-center justify-content-lg-end align-items-center" id="pills-tab" role="tablist">
                                    <li>
                                        {/* <button type="button" className="me-3 info-btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                            <CiCircleInfo />
                                        </button> */}
                                        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                    <div className="modal-header border-0 py-0 m-2 d-flex align-items-center justify-content-center">
                                                        <h1 className="modal-title fs-5" id="staticBackdropLabel" style={{ color: "#bc9018" }}>Reminder</h1>
                                                        <button type="button" style={{ position: "absolute", right: "10px" }} className="close-btn-1" data-bs-dismiss="modal" aria-label="Close"><IoMdClose /></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="submitSpans">
                                                            <div className="d-flex">
                                                                <p className="text-dark" style={{ textAlign: "end" }}>Transaction</p>
                                                                <div className="ms-0">
                                                                    <ul style={{ listStyleType: "initial", textAlign: "justify" }}>
                                                                        <li>Transaction History Withdraw and Deposit</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>


                                    {activeTab === 'deposit' && (
                                        <div className='row me-5'>
                                            <div className='col-lg-9'>
                                                <input class="form-control form-search " type="text" placeholder="Search By Email or Date" aria-label="default input example"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}

                                                />
                                            </div>

                                        </div>
                                    )}
                                    {activeTab === 'withdraw' && (
                                        <div className='row me-5'>
                                            <div className='col-lg-6'>
                                                <input class="form-control form-search " type="text" placeholder="Search By Email or Date" aria-label="default input example"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}

                                                />
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className="mb-0">
                                                    <select
                                                        className="form-select form-search"
                                                        value={filterStatus}
                                                        onChange={(e) => setFilterStatus(e.target.value ? Number(e.target.value) : null)}
                                                    >
                                                        <option value="">All</option>
                                                        <option value="1">Pending</option>
                                                        <option value="2">Approved</option>
                                                        <option value="3">Rejected</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link register-btn-2 me-lg-4 me-1 ${activeTab === 'deposit' ? 'active' : ''}`}
                                            id="pills-home-tab"
                                            onClick={() => handleTabChange('deposit')}
                                            type="button"
                                            role="tab"
                                            aria-selected={activeTab === 'deposit'}
                                        >
                                            Deposit
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link register-btn-2  ms-1 ${activeTab === 'withdraw' ? 'active' : ''}`}
                                            id="pills-profile-tab"
                                            onClick={() => handleTabChange('withdraw')}
                                            type="button"
                                            role="tab"
                                            aria-selected={activeTab === 'withdraw'}
                                        >
                                            Withdraw
                                        </button>
                                    </li>
                                </ul>
                                {copiedValue && <div className="alert alert-success">Copied: {copiedValue}</div>}
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="custom-datascroll">
                                        {loading ? (
                                            <div className="text-center"><Spinner animation="border" /></div>
                                        ) : activeTab === 'deposit' ? (
                                            <DataTable
                                                columns={columnsDeposit}
                                                data={filteredDeposit}
                                                pagination
                                                persistTableHead
                                                sortFunction={customSort}
                                                paginationPerPage={5}
                                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                                noDataComponent={<div className="text-center">No Data</div>}
                                            />
                                        ) : (

                                            <div>
                                                <div className="mb-2 mt-2 text-center">
                                                    <p>Admin commission Fee (10%): {totalCommissionFee} TEXA</p>
                                                </div>
                                                <DataTable
                                                    columns={columnsWithdraw}
                                                    data={filteredWithdraw}
                                                    pagination
                                                    persistTableHead
                                                    sortFunction={customSort}
                                                    paginationPerPage={5}
                                                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                                    noDataComponent={<div className="text-center">No Data</div>}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Transaction;
